const React = () => {
  return (
    <div>
      <h1>ReactPage</h1>
    </div>
  );
};

export default React;
